import './sendOtp.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import OtpInput from 'react-otp-input';
import LoadingOverlay from 'react-loading-overlay';
import { IRootState } from 'app/shared/reducers';
import { getSession } from 'app/shared/reducers/authentication';
import { sendOtp, reSendOtp, reset, updatePhoneNumber, storeInfoNewPhone, resendOtpUpdatePhoneNumber } from './sendOtp.reducer';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { NUMBER_OTP_FAIL, Rester_Type, SUCCESS } from 'app/config/constants';
import { UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ModalInputCaptcha from './modal-resend-otp';
import ModalUpdatePhone from './modalUpdatePhoneNumber';
import MessageModal from 'app/shared/message/message-modal';
import { login } from 'app/shared/util/utilities';

export interface ISendOtpProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface ISendOtpState {
  otp: string;
  visible: boolean;
  color: string;
  message: string;
  redirectReg: boolean;
  isShowModal: boolean;
  displayModalCaptcha: boolean;
  alertMess: string;
  isOpenAlert: boolean;
  messageModalUpdatePhone: string;
  isDisplayModalUpdatePhone: boolean;
  isDisplayModalSuccess: boolean;
  isDisable: boolean;
  showMessage: boolean;
  redirectLogin: boolean;
  type: string;
  timeLeft: number;
  timerOn: boolean;
}
export class SendOtpPage extends React.Component<ISendOtpProps, ISendOtpState> {
  timerID = null;
  state: ISendOtpState = {
    otp: '',
    visible: false,
    color: 'info',
    message: '',
    redirectReg: false,
    isShowModal: false,
    displayModalCaptcha: false,
    alertMess: '',
    isOpenAlert: false,
    messageModalUpdatePhone: '',
    isDisplayModalUpdatePhone: false,
    isDisplayModalSuccess: false,
    isDisable: false,
    showMessage: false,
    redirectLogin: false,
    type: '',
    timeLeft: 0,
    timerOn: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.updatePhone !== nextProps.updatePhone) {
      const { updatePhone } = nextProps;
      if (updatePhone && updatePhone.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          visible: true,
          color: 'danger',
          message: updatePhone.message,
          otp: '',
          isDisable: false
        });
      } else if (updatePhone && updatePhone.status === 'SUCCESS') {
        this.props.storeInfoNewPhone({});
        Storage.session.remove('count');
        this.setState({
          isDisplayModalSuccess: true
        });
      } else {
        this.setState({
          isDisplayModalUpdatePhone: true,
          messageModalUpdatePhone:
            'Thông tin định danh không khớp với thông tin thuê bao nhà mạng, Soạn TTTB gửi 1414 để kiểm tra và ra quầy giao dịch để cập nhật thông tin!'
        });
      }
    }

    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message,
          otp: ''
        });
      } else if (response && response.status !== 'SUCCESS') {
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message
        });
      } else if (response.status === 'SUCCESS') {
        this.setState({
          redirectLogin: true
        });
        // let timerId = setTimeout(() => {
        //   this.setState({
        //     showMessage: false,
        //     redirectLogin: true
        //   });
        // }, 3000);
      }
    }

    if (this.props.responseReSend !== nextProps.responseReSend) {
      const { responseReSend } = nextProps;
      if (responseReSend && responseReSend.status === 'SUCCESS') {
        Storage.session.remove('count');
        let { email, id, mobile, fullName, type } = this.props.location.state;
        this.setState({
          visible: true,
          color: 'success',
          message:
            type === Rester_Type.MOBILE
              ? translate('sendOtp.messages.sendotpSuccess')
              : translate('sendOtp.messages.sendotpSuccessTypeEmail'),
          displayModalCaptcha: false,
          otp: ''
        });
      } else if (responseReSend && responseReSend.status) {
        this.props.generateCaptcha();
        this.setState({
          color: 'danger',
          alertMess: responseReSend.message,
          isOpenAlert: true
        });
      }
      this.props.generateCaptcha();
    }

    if (this.props.registrationFailure !== nextProps.registrationFailure) {
      if (this.props.registrationFailure) {
        this.setState({
          visible: true,
          color: 'danger',
          message: 'Có lỗi xảy ra xảy ra. Xin vui lòng thử lại sau!'
        });
      }
    }
    let timerId = setTimeout(() => {
      this.setState({
        visible: false
      });
    }, 10000);
  }

  componentWillUnmount() {
    Storage.session.remove('count');
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  handleValidSubmit = () => {
    const { mobile, id } = this.props.location.state;
    let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
    if (count < NUMBER_OTP_FAIL) {
      if (this.state.otp) {
        if (!this.isDataEmpty(this.props.infoNewPhone)) {
          this.setState({
            isDisable: true
          });
          this.props.updatePhoneNumber(
            this.props.infoNewPhone.phone,
            this.props.infoNewPhone.keyLogin,
            this.state.otp,
            this.props.infoNewPhone.id
          );
        } else {
          this.props.sendOtp(id, this.state.otp);
        }
      } else {
        this.setState({
          visible: true,
          color: 'info',
          message: 'Bạn chưa nhập mã OTP.',
          isDisable: false
        });
        let timerId = setTimeout(() => {
          this.setState({
            visible: false
          });
        }, 3000);
      }
    } else {
      this.setState({
        isShowModal: true
      });
    }
  };

  isDataEmpty(ob) {
    for (var i in ob) {
      return false;
    }
    return true;
  }

  handleReSendOtp = () => {
    const { id, mobile } = this.props.location.state;
    if (id.indexOf('@') > 0) {
      this.props.reSendOtp(id, 'EMAIL', null);
    } else {
      this.props.reSendOtp(id, 'SMS', null);
    }

    this.setState({
      timerOn: true,
      timeLeft: 120
    });
    // if (mobile) {
    //   this.setState({
    //     displayModalCaptcha: true
    //   });
    // } else {
    //   this.props.reSendOtp(id, '');
    //   this.setState({
    //     timerOn: true,
    //     timeLeft: 120
    //   });
    // }
  };

  tick = () => {
    if (this.state.timerOn && this.state.timeLeft > 0) {
      this.setState({ timeLeft: this.state.timeLeft - 1 });
    } else {
      this.setState({ timerOn: false });
    }
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeConfirm = () => {
    this.setState({
      isShowModal: false,
      redirectReg: true
    });
    Storage.session.remove('count');
  };

  invokeAgree = formData => {
    const { id, mobile } = this.props.location.state;
    this.setState({
      type: formData
    });
    this.props.reSendOtp(id, formData, null);
    this.setState({
      timerOn: true,
      timeLeft: 120
    });
  };

  invokeCancel = () => {
    this.setState({
      displayModalCaptcha: false
    });
  };

  invokeDimiss = () => {
    this.setState({
      isOpenAlert: false
    });
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleValidSubmit();
    }
  };

  encryptoPhone = () => {
    var sdt = '';
    if (!this.isDataEmpty(this.props.infoNewPhone)) {
      let mobile = this.props.infoNewPhone.phone.startsWith('84')
        ? this.props.infoNewPhone.phone.replace('84', '0')
        : this.props.infoNewPhone.phone;
      sdt = mobile.slice(0, 3) + '****' + mobile.slice(7, mobile.length);
    }
    return sdt;
  };

  render() {
    if (!this.props.location.state) {
      return <div />;
    }
    const { response } = this.props;
    let { email, id, mobile, fullName, type } = this.props.location.state;
    let sdt = type === Rester_Type.MOBILE ? 'SĐT: ' + mobile : 'Email: ' + email;

    if (this.state.redirectLogin) {
      return (
        <Redirect
          push
          to={{
            pathname: '/register/addInfo',
            state: {
              mobile: mobile,
              email: email,
              type: type
            }
          }}
        />
        // login(this.props.config);
      );
    }

    if (this.state.isDisplayModalSuccess) {
      const timer = setTimeout(() => {
        login(this.props.config);
      }, 3000);
    }

    if (this.state.redirectReg) {
      return <Redirect push to="/register" />;
    }

    // if (email) {
    //   mobile = mobile.startsWith('84') ? mobile.replace('84', '0') : mobile;
    //   sdt = mobile.slice(0, 3) + '****' + mobile.slice(7, mobile.length);
    // }

    return (
      <div>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đăng ký thành công'} />

        {window['inputNumber']()}
        {this.props.isActive ? (
          <div className="loading-box">
            <LoadingOverlay
              active={true}
              styles={{
                wrapper: {
                  maxWidth: '200px',
                  width: '100%'
                },
                text: {
                  textAlign: 'center'
                }
              }}
              spinner
              text={
                <>
                  Hệ thống đang thực hiện xác thực thông tin với nhà mạng
                  <br />
                  Vui lòng chờ kết quả trong giây lát!
                </>
              }
            />
          </div>
        ) : null}
        <ModalInputCaptcha
          showModalCaptcha={this.state.displayModalCaptcha}
          invokeAgree={this.invokeAgree}
          invokeCancel={this.invokeCancel}
          errMessage={this.state.alertMess}
          isOpenAlert={this.state.isOpenAlert}
          dismissAlert={this.invokeDimiss}
          mobile={mobile}
          fullName={fullName}
          email={email}
        />
        <MessageModal
          type={SUCCESS}
          showModal={this.state.isDisplayModalSuccess}
          message={'Chúc mừng bạn đã đổi thành công số điện thoại nhận OTP'}
        />
        <ModalUpdatePhone isDisplay={this.state.isDisplayModalUpdatePhone} message={this.state.messageModalUpdatePhone} />
        {this.state.isShowModal ? (
          <Modal isOpen={this.state.isShowModal} centered={window.location === window.parent.location}>
            <ModalHeader>
              <label className="font-weight-bold">Thông Báo</label>
            </ModalHeader>
            <ModalBody className="padding-modal-body">
              <Row style={{ padding: '20px' }}>
                <label>
                  <span>Đăng ký tài khoản không thành công do bạn đã nhập sai mã OTP quá 5 lần, vui lòng thực hiện đăng ký lại!</span>
                </label>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="btn-register" onClick={this.invokeConfirm}>
                Xác nhận
              </Button>{' '}
            </ModalFooter>
          </Modal>
        ) : null}

        <Row className="justify-content-center">
          <Col className="box-otp">
            <h2 className="text-center font-weight-bold" id="password-title">
              <Translate contentKey="sendOtp.title">Nhập mã OTP</Translate>
            </h2>
            <h6 className="text-center txtContent font-weight-bold">
              <Translate
                contentKey="sendOtp.txtContent1"
                interpolate={{ email: !this.isDataEmpty(this.props.infoNewPhone) ? this.encryptoPhone() : sdt }}
              >
                Otp code has been sent via phone number: {!this.isDataEmpty(this.props.infoNewPhone) ? this.encryptoPhone() : sdt}
              </Translate>
            </h6>

            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>

            <AvForm className="text-center" id="password-form" onValidSubmit={this.handleValidSubmit} onKeyPress={this.handleKeyPress}>
              <p className="text-center">Nhập mã OTP</p>
              <div id="inputOtp">
                <OtpInput
                  inputStyle={{
                    width: '2.5rem',
                    height: '2.5rem',
                    margin: '5px 5px',
                    fontSize: '1.5rem',
                    borderRadius: 4,
                    border: '1px solid rgba(0,0,0,0.3)'
                  }}
                  numInputs={6}
                  onChange={otp => this.setState({ otp })}
                  value={this.state.otp}
                  shouldAutoFocus
                />
              </div>
              <p className="text-center">
                <label className="label-otp">{this.state.timeLeft === 0 ? 'Bạn chưa nhận được mã?' : 'Lấy lại mã sau thời gian:'}</label>
                {this.state.timeLeft === 0 ? (
                  <Button className="btnLink" color="link" type="button" onClick={() => this.handleReSendOtp()}>
                    GỬI LẠI NGAY
                  </Button>
                ) : (
                  <Button className="btnLink" color="link" type="button">
                    {this.state.timeLeft}s
                  </Button>
                )}
              </p>
              <Button className="btn-register" type="submit" disabled={this.state.isDisable} block>
                <Translate contentKey="sendOtp.form.button">Confirm</Translate>
              </Button>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ sendotp, applicationProfile }: IRootState) => ({
  response: sendotp.response,
  responseReSend: sendotp.responseReSend,
  registrationFailure: sendotp.registrationFailure,
  isActive: sendotp.loading,
  infoNewPhone: sendotp.infoNewPhone,
  updatePhone: sendotp.updatePhone,
  config: applicationProfile.config,
  resendOtpUpdatePhone: sendotp.resendOtpUpdatePhone
});

const mapDispatchToProps = {
  getSession,
  sendOtp,
  reSendOtp,
  generateCaptcha,
  reset,
  updatePhoneNumber,
  storeInfoNewPhone,
  resendOtpUpdatePhoneNumber
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendOtpPage);
